<div *ngIf="isloader" class="h-100 padt-5">
  <mat-progress-bar [mode]="'indeterminate'">
  </mat-progress-bar>
</div>
<div *ngIf="!isloader">
  <div [ngClass]="_service.rbacManagement('entities_DateTimeRangeFilter') ? 'd-flex vot-telematics': 'd-grid telematics-history-style' ">
    <div class="date justify-content-start" [ngClass]="_service.rbacManagement('entities_DateTimeRangeFilter') ? 'vot-time' : ''"><span class="date-label">Updated
        on</span>&nbsp;&nbsp;{{apiHitTime|date:'dd-MMM-y hh:mm:ss
      aaa':'en-US'}}</div>
    <div class="filter-gap">
      <div class="filter-drop-down dropdown  rt-filter category show-arrow">
        <mat-form-field appearance="outline">
          <mat-select [formControl]="pageSize" panelClass="multiSelectPanel" placeholder="Page Size">
            <mat-option *ngFor="let item of pageSizeLimit" [value]="item" (click)="activeEntityDetails(1)">
              {{item}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="filter-drop-down period cust-filter" *ngIf="!_service.rbacManagement('entities_DateTimeRangeFilter')">
        <mat-form-field appearance="outline">
          <input matInput [matDatepicker]="dp3" placeholder="Date" [formControl]="datePicker" [readonly]="true"
            (dateChange)="activeEntityDetails(1)">
          <mat-datepicker-toggle matSuffix [for]="dp3">
            <mat-icon matDatepickerToggleIcon>
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4.625 0.75C5.03921 0.75 5.375 1.08579 5.375 1.5V2.25H10.625V1.5C10.625 1.08579 10.9608 0.75 11.375 0.75C11.7892 0.75 12.125 1.08579 12.125
                            1.5V2.26852C14.02 2.45666 15.5 4.05549 15.5 6V12.75C15.5 14.8211 13.8211 16.5 11.75 16.5H4.25C2.17893 16.5 0.5 14.8211 0.5 12.75V6C0.5 4.05549 1.98 2.45666 3.875 2.26852V1.5C3.875 1.08579 4.21079 0.75 4.625
                            0.75ZM2.12803 5.25H13.872C13.5631 4.37611 12.7297 3.75 11.75 3.75H4.25C3.27034 3.75 2.43691 4.37611 2.12803 5.25ZM14 6.75H2V12.75C2 13.9926 3.00736 15 4.25 15H11.75C12.9926 15 14 13.9926 14 12.75V6.75ZM3.5
                            9C3.5 8.58579 3.83579 8.25 4.25 8.25H7.25C7.66421 8.25 8 8.58579 8 9V12C8 12.4142 7.66421 12.75 7.25 12.75H4.25C3.83579 12.75 3.5 12.4142 3.5 12V9ZM6.5 9.75H5V11.25H6.5V9.75Z"
                  fill="#055C7B" />
              </svg>
            </mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #dp3 disabled="false"></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="d-flex gap-2 align-items-center pr-5" *ngIf="_service.rbacManagement('entities_DateTimeRangeFilter')">
        <div class="widget-edit pdt-5 calender-pop-scroll report-date-field home-datetime-range">
          <form [formGroup]="datepickerForm">
          <app-datetime-range class="" formControlName="thisdate" [isDisabled]="false" [label]="'Date Range'" [autoApply]="false"
            [showCancel]="true" [timePicker]="true" [timePicker24Hour]="true" [timePickerSeconds]="true"
            [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [keepCalendarOpeningWithRange]="true" 
            [opens]="'left'" (datePassed)="saveTime($event)">
          </app-datetime-range>
          </form>
        </div>
      </div>
    </div>
  </div>
  <app-common-table [tableData]="transformedAttributeData"
    [columnHeader]="teleHistoryConfig?.attributesTableHeader?teleHistoryConfig?.attributesTableHeader:{}"
    [entityDetails]="entityData" pageType="trlWidgetNoExport" class="app-common-table" [exportRequired]="_service.rbacManagement('vehicles_Enrolled_TelematicsHistory_Exportdata')"
    [actionPermission]="tableActionList" [hasStickyHeader]="transformedAttributeData?.length > 0 ? true : false"
    (tableAction)="tableAction($event)">
  </app-common-table>
  <app-standard-pagination [pagination]="pager" backgroundColor="'#f8f8f8'"
    *ngIf="transformedAttributeData?.length && pager && pager?.pages?.length > 1"
    (paginationAction)="activeEntityDetails($event)">
  </app-standard-pagination>
</div>
<!-- <div *ngIf="!isloader && !transformedAttributeData?.length" class="text-center p-20-px">
  <img src="../../../../../../assets/images/no-data-idec.svg" matToolTip="No Data" class="h-150" alt="no data">
</div> -->